export default {
  modalOverlay: {
    position: 'fixed',
    right: 0,
    top: 0,
    left: 0,
    bottom: 0,
    alignItems: 'center',
    justifyContent: 'center',
    opacity: '1',
    overflow: 'hidden',
    padding: '1rem',
    background: 'rgba(220,221,222,0.6)',
    display: 'flex',
  },
  modalContainer: {
    maxWidth: 'none',
  },
  modalHeader: {
    display: 'flex',
  },
  modalTitle: {
    flex: '1 1 100%',
  },
  button: {
    flex: '0 0 40px',
    height: '33px',
    marginTop: '20px',
  },
}
